module.exports = __webpack_public_path__ + "static/img/farmhand.739737b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/farmhand.png
// module id = 308
// module chunks = 6